import { TnvedCode } from '../types';

/**
 * Статичный справочник ТНВЭД кодов
 * ТНВЭД - Товарная номенклатура внешнеэкономической деятельности
 */
export const MOCK_TNVED_CODES: TnvedCode[] = [
  {
    id: '1',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '0201',
    name: 'Мясо крупного рогатого скота, свежее или охлажденное'
  },
  {
    id: '2',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '0401',
    name: 'Молоко и сливки, несгущенные, без добавления сахара'
  },
  {
    id: '3',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '0701',
    name: 'Картофель свежий или охлажденный'
  },
  {
    id: '4',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '0805',
    name: 'Цитрусовые плоды, свежие или сушеные'
  },
  {
    id: '5',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '1001',
    name: 'Пшеница и меслин'
  },
  {
    id: '6',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '1701',
    name: 'Сахар тростниковый или свекловичный'
  },
  {
    id: '7',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '1801',
    name: 'Какао-бобы, целые или дробленые, сырые или жареные'
  },
  {
    id: '8',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '2203',
    name: 'Пиво солодовое'
  },
  {
    id: '9',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '2710',
    name: 'Нефтепродукты'
  },
  {
    id: '10',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '3004',
    name: 'Лекарственные средства'
  },
  {
    id: '11',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '4011',
    name: 'Шины пневматические резиновые новые'
  },
  {
    id: '12',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '6109',
    name: 'Футболки, майки и аналогичные изделия трикотажные'
  },
  {
    id: '13',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '8471',
    name: 'Вычислительные машины и их блоки'
  },
  {
    id: '14',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '8517',
    name: 'Телефонные аппараты и средства связи'
  },
  {
    id: '15',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '9401',
    name: 'Мебель для сидения'
  }
];
